import { Room, TwilioError } from 'twilio-video';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Callback } from '../../../types';

export default function useHandleRoomDisconnection(
  room: Room | null,
  onError: Callback,
  removeLocalAudioTrack: () => void,
  removeLocalVideoTrack: () => void,
  isSharingScreen: boolean,
  toggleScreenShare: () => void
) {
  const navigate = useNavigate();

  useEffect(() => {
    if (room) {
      const onDisconnected = (_: Room, error: TwilioError) => {
        if (error) {
          const { message, code } = error
          
          if(code === 53405) { // Internet connection lost error code : 53405
            console.log("onDisconnected-useHandleRoomDisconnection",code,message);
            navigate('/timeout', { replace: true });
          } else {
            onError(error);
          }
        }

        removeLocalAudioTrack();
        removeLocalVideoTrack();
        if (isSharingScreen) {
          toggleScreenShare();
        }
      };

      room.on('disconnected', onDisconnected);
      return () => {
        room.off('disconnected', onDisconnected);
      };
    }
  }, [room, onError, removeLocalAudioTrack, removeLocalVideoTrack, isSharingScreen, toggleScreenShare]);
}
